import containsOv from "./containsOv"

const getMovieTitle = movieData => {
    const { technologyAttributes, titleDisplay, origTitle, title } = movieData

    if(titleDisplay) {
        return titleDisplay
    } else if(containsOv(technologyAttributes) && origTitle ) {
        return origTitle
    } else {
        return title
    }
}

export default getMovieTitle